// shadcn input https://ui.shadcn.com/docs/components/input
// Retokenized to match Wayflyer redesign (paper.design node 50M-0).

import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={cn(
        "text-ds-body-md text-grey-900 placeholder:text-grey-500 bg-grey-0 rounded-ds-m flex h-11 w-full border px-3 py-1",
        "border-grey-200 hover:border-grey-500",
        "file:text-grey-900 file:border-0 file:bg-transparent file:text-sm file:font-medium",
        "transition-colors duration-[180ms] [transition-timing-function:cubic-bezier(0.2,0.8,0.2,1)]",
        // Focus: animated gradient border — the one brand moment per screen in forms (DESIGN.md).
        // Border stays transparent; double-background paints --gradient-focus through it (paper 4C2-0).
        "focus-visible:border-[1.5px] focus-visible:border-transparent focus-visible:outline-none",
        "focus-visible:[background-image:linear-gradient(var(--grey-0),var(--grey-0)),var(--gradient-focus)] focus-visible:[background-clip:padding-box,border-box] focus-visible:[background-origin:border-box]",
        "focus-visible:[box-shadow:var(--shadow-focus-glow)]",
        // Error: aria-invalid is the contract (stock shadcn convention).
        "aria-[invalid=true]:border-red-500 aria-[invalid=true]:bg-red-50",
        // Disabled
        "disabled:bg-grey-50 disabled:border-grey-100 disabled:text-grey-300 disabled:cursor-not-allowed",
        className
      )}
      {...props}
    />
  )
);
Input.displayName = "Input";

export { Input };
